<div class="action-container">
  <app-ag-action-icon-button
    iconClass="ic-eye-16"
    (action)="openAlert()"
  />

  <div
    ngbDropdown
    container="body"
    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
    class="dropdown d-inline-flex"
    *appHasRole="['Admin', 'Manager', 'Preparer']"
  >
    <app-ag-action-icon-button ngbDropdownToggle iconClass="ic-more-horizontal-16"/>

    <div ngbDropdownMenu aria-labelledby="bulk-actions-dd" class="dropdown-menu dropdown-menu-right">
      @if (!isRead) {
        <button ngbDropdownItem (click)="markRead()">
          <i class="icon ic-checkmark-circle-20"></i>
          <span>Mark as Read</span>
        </button>
      }

      @if (!needAttention) {
        <button ngbDropdownItem (click)="markRequireAttention()">
          <i class="icon ic-info-circle-20"></i>
          <span>Mark as Require Attention</span>
        </button>
      }

      @if (canBeArchived) {
        <button ngbDropdownItem (click)="archive()">
          <i class="icon ic-archive-20"></i>
          <span>Archive</span>
        </button>
      }

<!--      @if (status !== AlertStatus.Ignored && allowChangeToIgnoredOrPostponed) {-->
<!--        <button ngbDropdownItem (click)="ignore()">-->
<!--          <i class="icon ic-ignore-20"></i>-->
<!--          <span>Ignore</span>-->
<!--        </button>-->
<!--      }-->

      @if (status !== AlertStatus.Postponed && allowChangeToIgnoredOrPostponed) {
        <div ngbDropdown [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']" class="dropdown">
          <button ngbDropdownToggle class="dropdown-button d-flex gap-8 border-0 bg-transparent py-2 font-weight-normal">
            <i class="icon ic-clock-20"></i>
            <span>Postpone</span>

            <div class="flex-grow-1 d-flex flex-row-reverse">
              <i class="icon ic-chevron-down-20"></i>
            </div>
          </button>

          <div ngbDropdownMenu aria-labelledby="bulk-actions-dd" class="dropdown-menu dropdown-menu-right">
            @for (item of postponeMenu; track $index) {
              <button class="dropdown-item" (click)="postpone(item.value)">
                <span>{{ item.label }}</span>
              </button>
            }
          </div>
        </div>
      }

      @if (showDownloadBtn) {
        <div class="dropdown-item" (click)="download()">
          <i class="icon ic-download-20"></i>
          <span>Download</span>
        </div>
      }
    </div>
  </div>
</div>
